import { PropsWithChildren, useEffect } from "react"
import { CHART_X_PADDING } from "../../../components/chart/hooks"
import MaxWidthContainer from "../../../components/layouts/common/MaxWidthContainer"
import { micrositeGlobalStyles, styled, theme } from "../../../styles/stitches.config"

export const HeaderContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "none",
  alignItems: "center",

  paddingInline: theme.space.s6,

  "@lg": {
    alignItems: "flex-end",
  },
})

export const FooterContainer = styled("div", {
  display: "block",

  gap: theme.space.s6,
  paddingBottom: theme.space.s6,
  paddingInline: theme.space.s6,

  "@sm": {
    display: "flex",
    flexDirection: "column",
    justifyContent: "unset",
    alignItems: "center",
  },

  "@media(min-width: 960px)": {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "unset",
    paddingInline: CHART_X_PADDING,
  },
})

export const ConfigContainer = styled("div", {
  display: "flex",
  flexDirection: "column",

  "@lg": {
    alignItems: "end",
  },
})

const useResizeScript = () => {
  useEffect(() => {
    const script = document.createElement("script")

    script.src = "/webflow/iframeResizer.contentWindow.js"
    script.async = true

    document.body.append(script)

    return () => {
      script.remove()
    }
  }, [])
}

export const PageContainer = ({ children }: PropsWithChildren) => {
  useResizeScript()
  micrositeGlobalStyles()

  return <MaxWidthContainer>{children}</MaxWidthContainer>
}
